import { Bureau } from '../../../core/shared/classes/bureau';
import { Role } from './role';

export interface IRoleByBureau {
    bureau: Bureau;
    commerciaux: Role[];
}

export class RoleByBureau {
    roles: Role[];
    bureaux: Bureau[];

    get filteredRoleByBureau(): Array<IRoleByBureau> | null {
        if (!this.roles) {
            return null;
        }

        const tmpFilter = {};
        this.roles.map((role: Role) => {
            if (role.bureau_concerne) {
                for (const bureauId in role.bureau_concerne) {
                    if (role.bureau_concerne.hasOwnProperty(bureauId)) {
                        if (tmpFilter[bureauId] === undefined) {
                            tmpFilter[bureauId] = {
                                bureau: new Bureau(role.bureau_concerne[bureauId]),
                                commerciaux: []
                            };
                        }
                        tmpFilter[bureauId].commerciaux.push(role);
                    }
                }
            }
        });

        return Object.values(tmpFilter);
    }

    static filterRoleByBureau(roles: Role[]): Array<IRoleByBureau> | null {
        const rbb = new RoleByBureau();
        rbb.roles = roles;

        return rbb.filteredRoleByBureau;
    }
}
